module.exports = __webpack_public_path__ + "static/media/modal-1-body.14570983.svg";


//////////////////
// WEBPACK FOOTER
// ./src/MatchingRules/modal-1-body.svg
// module id = ./src/MatchingRules/modal-1-body.svg
// module chunks = 0